import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import SearchPage from "@/pages/SearchPage";
import { UrduAdabPage, AboutPage } from "@/pages/StaticPages";
import { AuthorsPage, AuthorPage } from "@/pages/Authors";
import { GenresPage, GenrePage } from "@/pages/Genres";
import { HistoryPage, EraPage } from "@/pages/History";
import { ArticlesPage, ArticlePage } from "@/pages/Articles";
import MediaPage from "@/pages/MediaPage";
import JournalsPage from "@/pages/JournalsPage";
import { UgcPage, UnitPage } from "@/pages/Ugc";
import TheoryPage from "@/pages/TheoryPage";
import WorkPage from "@/pages/WorkPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const NotFound = () => (
  <div className="py-24 text-center" data-testid="not-found">
    <h1 className="text-4xl font-bold text-[#2a1508] leading-[2]">صفحہ نہیں ملا</h1>
    <Link to="/" className="inline-block mt-6 px-6 py-2 rounded-full bg-[#2a1508] text-[#f5efe3] hover:bg-[#4a2b16] transition-colors" data-testid="not-found-home">
      صفحۂ اول
    </Link>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#f5efe3] text-[#1a0d05]">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/urdu-adab" element={<UrduAdabPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/authors" element={<AuthorsPage />} />
            <Route path="/authors/:slug" element={<AuthorPage />} />
            <Route path="/genres" element={<GenresPage />} />
            <Route path="/genres/:slug" element={<GenrePage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/history/:slug" element={<EraPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/articles/:slug" element={<ArticlePage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/journals" element={<JournalsPage />} />
            <Route path="/ugc-net" element={<UgcPage />} />
            <Route path="/ugc-net/unit/:num" element={<UnitPage />} />
            <Route path="/pages/:slug" element={<TheoryPage />} />
            <Route path="/works/:slug" element={<WorkPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <Toaster position="bottom-center" richColors />
      </div>
    </BrowserRouter>
  );
}
